import * as React from 'react';
import injectSheet from 'react-jss';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { setLogout } from '../../actions/authentication';
import withAuthAccessExim from '../hoc/withAuthAccessExim';
import { LOGOUT } from '../../utils/partsToShow/partsConstants';
import { Alert } from 'antd';
import { getLoginRoute } from 'src/routing/utils';

const styles = {
  messageContainer: {
    position: 'fixed',
    top: '40px',
    zIndex: '20',
    width: '80%',
    marginLeft: '10%',
  },
  lightdimmer: {
    backgroundColor: 'rgba(0, 0, 0, 0.3) !important',
  },
};

class Logout extends React.PureComponent<any, any> {

  componentDidMount() {
    this.props.setLogout();
    const { history } = this.props;
    setTimeout(() => {
      // history.push(getLoginRoute());
      window.location.href = getLoginRoute();
    }, 2000);

  }

  render() {
    const { classes, forceLogout, logout } = this.props;
    let logoutMessage: any = null;
    if (logout) {
      logoutMessage = 'To continue, please login again.';
    } else if (forceLogout) {
      logoutMessage = 'Your session has expired. Please login to continue.';
    }
    if (!logoutMessage) {
      return null;
    }
    return <Alert className={classes.messageContainer}
      message="You have been logged out."
      description={logoutMessage}
      type="success"
      showIcon
    />;

  }
}

const mapStateToProps = ({ logoutReducer }) => {
  return {
    logout: logoutReducer.logout,
    forceLogout: logoutReducer.forceLogout,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({ setLogout }, dispatch);
};

export const LogoutStyled = injectSheet(styles)(Logout);
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(LogoutStyled));
